import React from 'react';
import { Container } from 'reactstrap';
import classNames from 'classnames';
import NeedHelp from '../../../components/modals/NeedHelp/NeedHelp';
import styles from './ApplestandaloneFooter.module.css';

const ApplestandaloneFooter = () => {
    return (
        <>
            <Container className={classNames(styles.footerText, 'px-3')}>
                <p>
                    AppleCare+ provides coverage for mechanical failure, electrical failure and accidental damage from
                    handling (ADH). AIG Standalone Protection does not provide coverage for mechanical failure,
                    electrical failure and accidental damage from handling (ADH). For complete details, see the
                    <a
                        href='#'
                        className='ml-1'
                        onClick={(e) => {
                            e.preventDefault();
                            window.open('/coveragedocs', '_blank');
                        }}
                    >
                        coverage details
                    </a>{' '}
                    applicable to your state.
                </p>
                <p>
                    AIG Standalone Protection Plans are sold and administered by AIG WarrantyGuard, Inc., part of AIG,
                    or one or more of its affiliates. Plans are subject to detailed terms, conditions and limitations.
                    For further information, please review the full plan
                    <a
                        href='#'
                        className='ml-1 mr-1'
                        onClick={(e) => {
                            e.preventDefault();
                            window.open('/coveragedocs', '_blank');
                        }}
                    >
                        terms and conditions.
                    </a>
                    Apple is not affiliated with AIG or any of its affiliates. Apple trademarks used with permission.
                </p>
            </Container>
            <footer className={styles.applestandaloneFooter}>
                <Container className={classNames(styles.footerPadding, 'px-0')}>
                    <ul className={styles.navItem}>
                        <li>
                            <a
                                href='https://www.aig.com/privacy-policy'
                                target='_blank'
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a
                                href='https://www.aig.com/terms-of-use'
                                target='_blank'
                            >
                                Terms of Use
                            </a>
                        </li>
                    </ul>
                    <p>
                        Copyright &#169; {new Date().getFullYear()}, American International Group, Inc. All rights
                        reserved.
                    </p>
                </Container>
                <NeedHelp />
            </footer>
        </>
    );
};

export default ApplestandaloneFooter;
